import { InputAdornment, Stack, TextField } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Controller, useFormContext } from 'react-hook-form';
import { FormState } from '../AddToCartDialog';
import { DATE_FORMAT } from 'components/constants/Constants';
import dayjs from 'dayjs';

export const AddToCartForm = () => {
  const {
    control,
    register,
    formState: { errors }
  } = useFormContext<FormState>();

  return (
    <Stack
      direction="row"
      gap={1}
      justifySelf="right"
      flexWrap={'wrap'}
      width={'100%'}
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Controller
          name="neededBy"
          control={control}
          render={({ field: { onChange, value } }) => (
            <DatePicker
              slotProps={{
                textField: {
                  margin: 'dense'
                },
                field: {
                  clearable: true
                }
              }}
              sx={{ flexGrow: 1 }}
              format={DATE_FORMAT}
              minDate={dayjs()}
              label="Needed by"
              value={value ? dayjs(value) : null}
              onChange={value =>
                onChange(value ? value.startOf('day').toDate() : null)
              }
            />
          )}
        />
      </LocalizationProvider>
      <TextField
        required
        label="Number of Samples"
        type="number"
        margin="dense"
        sx={{ flexGrow: 1 }}
        {...register('quantity', {
          required: 'Quantity is required',
          min: { value: 1, message: 'Must be greater than zero' }
        })}
        error={!!errors.quantity}
        helperText={errors.quantity?.message}
        slotProps={{
          input: {
            endAdornment: <InputAdornment position="end">units</InputAdornment>
          }
        }}
      />
      <TextField
        label="Estimated Yearly Usage"
        type="number"
        margin="dense"
        sx={{ width: 'max-content', flexGrow: 1 }}
        {...register('estimatedYearlyUsage', {
          required: false,
          min: { value: 1, message: 'Must be greater than zero' }
        })}
        error={!!errors.estimatedYearlyUsage}
        helperText={errors.estimatedYearlyUsage?.message}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end" sx={{ paddingLeft: 1 }}>
                kg
              </InputAdornment>
            )
          }
        }}
      />
    </Stack>
  );
};
